import { CaseRunClient, CaseRunDetailResponseWithUrls, DeconvMainCaseRunDetailReadModel, MaxLrAicCaseRunDetailReadModel, MaxLrCaseRunDetailReadModel, RunParameterModel } from '@app/api2/api';
import { BPBoxWithHeader } from '@app/components/React/Common/BPBoxWithHeader';
import { BPTabPane } from '@app/components/React/Common/BPTabPane';
import { PageBreak } from '@app/components/React/Common/PageBreak';
import * as React from 'react';
import { Menu, Tab } from 'semantic-ui-react';
import { PrintContext } from '../../../Print/PrintContext';
import { DeconvProfileSummaryTable } from './DeconvProfileSummaryTable';
import { Hypothesis } from './Hypothesis';
import { Overview } from './Overview';

type MaxLrBasedRunType = MaxLrCaseRunDetailReadModel | MaxLrAicCaseRunDetailReadModel | DeconvMainCaseRunDetailReadModel;

export interface IMaxLrCaseRunResultsProps {
    labId: number;
    caseId: number
    caseRunId: number;
}

export class IMaxLrCaseRunResultsState {
    parameters: RunParameterModel[] = [];
    model: MaxLrBasedRunType;
    res: CaseRunDetailResponseWithUrls = {};
    showPrintDialog: boolean = false;
}

export class MaxLrCaseRunResults extends React.Component<IMaxLrCaseRunResultsProps, IMaxLrCaseRunResultsState> {
    private caseRunClient = new CaseRunClient();

    constructor(props: IMaxLrCaseRunResultsProps) {
        super(props);

        this.state = new IMaxLrCaseRunResultsState();
    }

    componentDidMount() {
        this.loadData();
    }

    async loadData() {
        let res = await this.caseRunClient.results(this.props.labId, this.props.caseId, this.props.caseRunId);

        this.setState({
            model: res.detail as MaxLrBasedRunType,
            res: res,
            parameters: res.detail.parameters.map(m => {
                var res = { ...m, minValue: 0, maxValue: 0, required: false, aicEditable: false, userEditable: false, copyFromParent: false, order: m.order, userVisible: m.userVisible, isSecondary: false};
                return res;
            }),
        });
    }

    public render() {
        // if (this.state.model == null) {
        //     return <BPLoading />
        // } else {
        return <PrintContext.Consumer>{printOptions => {
            const panes = [
                {
                    menuItem: window.translation.caseRunView.overview,
                    pane: <BPTabPane loading={this.state.model == null} key={'overviewPane'}><Overview model={this.state.model} /></BPTabPane>
                },
                ...this.state.model?.runType != 'deconv_main' ? [
                    ...this.state.model?.useHp ? [{
                        menuItem: <Menu.Item key={'maxlrhp'}><span dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hp }} /></Menu.Item>,
                        pane: <BPTabPane loading={this.state.model == null} key="hpPane"><Hypothesis forPrint={printOptions} model={this.state.model?.results?.hypotheses.find(x => x.type == 'p')} /></BPTabPane>
                    }] : [],
                    ...this.state.model?.useHd ? [{
                        menuItem: <Menu.Item key={'maxlrhd'}><span dangerouslySetInnerHTML={{ __html: window.translation.caseRunView.hd }} /></Menu.Item>,
                        pane: <BPTabPane loading={this.state.model == null} key="hdPane"><Hypothesis forPrint={printOptions} model={this.state.model?.results?.hypotheses.find(x => x.type == 'd')} /></BPTabPane>
                    }] : []
                ] : [
                    {
                        menuItem: window.translation.caseRunView.marginalGenotypesSummaryTable,
                        pane: <BPTabPane loading={this.state.model == null} key={'decsumm'}>
                            <DeconvProfileSummaryTable labId={this.props.labId} caseId={this.props.caseId} caseRunId={this.props.caseRunId} format={'genotype'} />
                        </BPTabPane>
                    },
                    {
                        menuItem: window.translation.caseRunView.marginalAllelesSummaryTable,
                        pane: <BPTabPane loading={this.state.model == null} key={'decsumm_alleles'}>
                            <DeconvProfileSummaryTable labId={this.props.labId} caseId={this.props.caseId} caseRunId={this.props.caseRunId} format={'allele'} />
                        </BPTabPane>
                    },

                ],
            ];

            return !printOptions ? (
                <Tab renderActiveOnly={false} panes={panes} menu={{ attached: false, secondary: true, pointing: true }} />
            ) : panes.map((x, idx) => (<React.Fragment key={`${x.menuItem}_${idx}_div`}>
                {<PageBreak key={`${x.menuItem}_${idx}_break`} />}
                <BPBoxWithHeader key={`${x.menuItem}_${idx}_header`} forPrint={printOptions != null} header={x.menuItem}>
                    {x.pane}
                </BPBoxWithHeader>
            </React.Fragment>));
        }}</PrintContext.Consumer>
        // }
    }
}





